import { render, staticRenderFns } from "./LinkedTags.vue?vue&type=template&id=23f8cb48&"
import script from "./LinkedTags.vue?vue&type=script&lang=js&"
export * from "./LinkedTags.vue?vue&type=script&lang=js&"
import style0 from "./LinkedTags.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports